import { Form, Input, InputNumber, Switch } from "antd";

export const titleFormItem = (required:boolean = false) => {
  return (
    <Form.Item
      name="title"
      label="Title"
      rules={[{ required: required, message: "Please enter the title" }]}
    >
      <Input placeholder="Title" />
    </Form.Item>
  );
};

export const descriptionFormItem = (required:boolean = false) => {
    return <Form.Item
    name="description"
    label="Description"
    rules={[{ required: required, message: "Please enter the description" }]}
  >
    <Input placeholder="Description" />
  </Form.Item>
}

export const teamNameFormItem = (required:boolean = false) => {
    return <Form.Item
    name="name"
    label="Team Name"
    rules={[{ required: required, message: "Please enter the team name" }]}
  >
    <Input placeholder="Team Name" />
  </Form.Item>
}

export const serviceNameFormItem = (required:boolean = false) => {
    return <Form.Item
    name="name"
    label="Service Name"
    rules={[{ required: required, message: "Please enter the service name" }]}
  >
    <Input placeholder="Service Name" />
  </Form.Item>
}

export const serviceLevelFormItem = (required: boolean = false) => {
  return <Form.Item
    name="serviceLevel"
    label="Service Level"
    rules={[{ required: required, message: "Please enter the service level" }]}
  >
    <InputNumber
      placeholder="Service Level"
      style={{ width: "100%" }}
      precision={0}
      parser={(value) => value?.replace(/[^\d]/g, '') as any}
      onKeyDown={(e) => {
        if (!/^\d$/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
          e.preventDefault();
        } 
      }}
    />
  </Form.Item>
}

export const activeFormItem = (handleSwitchChange: any) => {
  return (
    <Form.Item label="Active" name="isActive" valuePropName="checked">
      <Switch onChange={handleSwitchChange} />
    </Form.Item>
  );
};
